<div class="overlay-inner-wrapper" id="zaehler-verwaltung">
  @let formType = ZAEHLER_MODE[mode()] | titlecase;
  <header class="header-2 scroll-x">
    <div class="branding">
      <span class="title">
        {{ formType + ' konfigurieren' | mrTranslate }}
      </span>
    </div>
    <div class="header-actions">
      @if (objekte(); as objmap) {
        <div class="clr-form-horizontal">
          <clr-select-container class="margin-16-t margin-3-r">
            <label class="w-auto padding-3-r">
              @let symbol = objmap[otypid()].symbol;
              <cds-icon class="fill-black grid-icon" [shape]="'objekttyp' + symbol" size="22" />
            </label>
            <select clrSelect class="cur-color" [(ngModel)]="otypid" [ngModelOptions]="{ standalone: true }">
              @for (typ of objmap | keyvalue; track typ.key) {
                <option [ngValue]="+typ.key">{{ typ.value.bezeichnung }}</option>
              }
            </select>
          </clr-select-container>
        </div>
      } @else {
        <div class="d-f clr-align-items-center">
          <clr-spinner [clrSmall]="true" />
        </div>
      }
      <clr-dropdown>
        <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
          <cds-icon shape="cog" />
        </button>
        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
          <a (click)="startExport()" clrDropdownItem>
            {{ `${isMultiModeNames() ? 'Ausgewählte' : 'Alle'} ${formType}programme exportieren` | mrTranslate }}
          </a>
          <a
            href="javascript:void(0);"
            clrDropdownItem
            (click)="isOpenModalZaehlerImport.set(true)"
            [class.deactivate]="!otypid()">
            {{ formType + 'programme importieren' | mrTranslate }}
          </a>
        </clr-dropdown-menu>
      </clr-dropdown>
      <div class="header-nav">
        <a class="nav-link nav-icon close" href="javascript:void(0);" (click)="close()">
          <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
        </a>
      </div>
    </div>
  </header>
  <div class="w-100-p padding-12-b scroll-y h-60 clr-row nxm">
    @if (zaehlerNamesRs.isLoading()) {
      <clr-spinner class="centred" />
    } @else {
      @let table = zaehlerNamesRs.value();
      <div id="namesContainer" class="clr-col-xl-{{ selectedName() ? 3 : 12 }} d-f col">
        <div class="card d-f col" style="height: 60vh">
          <div class="card-header padding-6-tb padding-12-l">
            {{ formType + 'programm' | mrTranslate }}
            <button class="btn btn-icon btn-sm nym" (click)="isMultiModeNames.set(!isMultiModeNames())">
              @let shape = isMultiModeNames() ? 'times-circle' : 'layers';
              @let title = isMultiModeNames() ? 'abbrechen' : 'starten';
              <cds-icon
                [shape]="shape"
                solid="true"
                [title]="('Multi-Auswahl' | mrTranslate) + ' ' + (title | mrTranslate)" />
            </button>
          </div>
          <div #zNamesContainer class="card-block flex-1-1-auto d-f col padding-3">
            @if (table.columns | array: 'filter' : filterTrackColumns; as columns) {
              <clr-datagrid
                class="datagrid-compact fill-space mw-0"
                [clrDgItemsIdentityFn]="row => row?.ID"
                [clrDgSelectionType]="isMultiModeNames() ? 'multi' : 'single'"
                [(clrDgSelected)]="selectedNames"
                [clrDgRowSelection]="true">
                @for (column of columns; track column.id) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['hashelper'] }">
                      {{ column.id | transformColNames: tol() | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row *clrDgItems="let row of table.rows" [clrDgItem]="row" id="i-{{ row.ID }}">
                  @for (cell of columns; track cell.id) {
                    <clr-dg-cell class="name-cell">
                      @let value = cell.id.startsWith('Track') ? Track_Map.get(row[cell.id]) : row[cell.id];
                      {{ value | tablePrettyPrint }}
                    </clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </div>
          <div class="card-footer">
            <div class="btn-group btn-primary btn-icon margin-0-t">
              <button class="btn btn-icon btn-success" [title]="'Neu' | mrTranslate" (click)="addItem('name')">
                <cds-icon shape="file" />
              </button>
              <button
                class="btn btn-icon margin-12-l"
                [title]="'Bearbeiten' | mrTranslate"
                (click)="editItem('name')"
                [disabled]="!selectedNameID()">
                <cds-icon shape="pencil" />
              </button>
              <button
                class="btn btn-icon btn-danger"
                [title]="'Löschen' | mrTranslate"
                (click)="deleteItem('name')"
                [disabled]="!selectedNameID()">
                <cds-icon shape="times" />
              </button>
              <button
                class="btn btn-icon btn-success margin-12-l"
                [title]="'Kopie erstellen' | mrTranslate"
                (click)="copyItem('name')"
                [disabled]="!selectedNameID()">
                <cds-icon shape="copy" />
              </button>
            </div>
            <button
              class="btn btn-icon"
              style="margin-left: auto"
              [title]="'Beschreibung' | mrTranslate"
              (click)="isOpenModalHelper.set(true)"
              [disabled]="!selectedNameID()">
              <cds-icon shape="help" />
            </button>
            <button
              class="btn btn-icon"
              [title]="'Skizzenpunkte' | mrTranslate"
              (click)="isOpenModalSkizzen.set(true)"
              [disabled]="!selectedSkizze()">
              <cds-icon shape="image" />
            </button>
          </div>
        </div>
        <div><ng-container *ngTemplateOutlet="preview; context: { readonly: true }" /></div>
      </div>
    }
    @if (zaehlerWerteRs.isLoading()) {
      <clr-spinner class="centred" />
    } @else if (selectedName()) {
      @let table = zaehlerWerteRs.value();
      <div id="werteContainer" class="clr-col-xl-9 d-f col auto-height-xl-100">
        <div class="card d-f col flex-1-1-auto">
          <div class="card-header padding-6-tb padding-12-l">
            {{ formType + 'werte SA' | mrTranslate }}
            <button class="btn btn-icon btn-sm nym" (click)="isMultiModeWerte.set(!isMultiModeWerte())">
              @let shape = isMultiModeWerte() ? 'times-circle' : 'layers';
              @let title = isMultiModeWerte() ? 'abbrechen' : 'starten';
              <cds-icon
                [shape]="shape"
                solid="true"
                [title]="('Multi-Auswahl' | mrTranslate) + ' ' + (title | mrTranslate)" />
            </button>
          </div>
          <div #zWerteContainer class="card-block flex-1-1-auto d-f col padding-3">
            @if (
              table.columns | filterTolByOptions: selectedName() | array: 'filter' : filterTrackColumns;
              as columns
            ) {
              <clr-datagrid
                #wertGrid
                class="datagrid-compact fill-space"
                [clrDgRowSelection]="true"
                [clrDgItemsIdentityFn]="row => row?.ID"
                cdkDropList
                [cdkDropListData]="table.rows"
                (cdkDropListDropped)="moveDrop($event)"
                [clrDgSelectionType]="isMultiModeWerte() ? 'multi' : 'single'"
                [(clrDgSelected)]="selectedWerte">
                <clr-dg-column class="fixed-cell" />
                @for (column of columns; track column.id) {
                  <clr-dg-column>
                    <ng-container
                      *clrDgHideableColumn="{
                        hidden: column.id | hideIDColumns: ['szaehnid', 'i_sort', 'zeinheit'],
                      }">
                      {{ column.id | transformColNames: tol(): isMessGeraetOptionOn() | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <clr-dg-row
                  *clrDgItems="let row of table.rows; let i = index"
                  [clrDgItem]="row"
                  cdkDrag
                  [cdkDragData]="i"
                  id="i-{{ row.ID }}"
                  [class.headerRow]="row.ZType == ZType_Header">
                  <span *cdkDragPreview>
                    {{ row.Code }}
                  </span>

                  <clr-dg-cell class="fixed-cell cursor-grab" cdkDragHandle>
                    <cds-icon shape="ellipsis-vertical" size="10" />
                  </clr-dg-cell>

                  @for (cell of columns; track cell.id) {
                    <clr-dg-cell class="name-cell">
                      {{ row | werteRowValues: cell.id: isMessGeraetOptionOn() | tablePrettyPrint }}
                    </clr-dg-cell>
                  }
                </clr-dg-row>
                <clr-dg-footer>{{ table.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            } @else {
              <clr-spinner class="centred" />
            }
          </div>
          <div class="card-footer">
            <div class="btn-group btn-primary btn-icon margin-0-t">
              <button class="btn btn-icon btn-success" [title]="'Neu' | mrTranslate" (click)="addItem('wert')">
                <cds-icon shape="file" />
              </button>
              <button
                class="btn btn-icon margin-12-l"
                [title]="'Bearbeiten' | mrTranslate"
                (click)="editItem('wert')"
                [disabled]="selectedWerte().length != 1">
                <cds-icon shape="pencil" />
              </button>
              <button
                class="btn btn-icon btn-danger"
                [title]="'Löschen' | mrTranslate"
                (click)="deleteItem('wert')"
                [disabled]="!selectedWerte().length">
                <cds-icon shape="times" />
              </button>
            </div>
            <div class="btn-group btn-outline margin-0-t">
              @if (!copiedWerte().length) {
                <button
                  class="btn btn-icon"
                  (click)="copiedWerte.set(selectedWerte())"
                  [disabled]="!selectedWerte().length">
                  <cds-icon shape="copy" />
                  {{ 'Kopieren' | mrTranslate }}
                </button>
              } @else {
                <button class="btn btn-icon" (click)="copiedWerte.set([])">
                  <cds-icon shape="copy" />
                  {{ 'Abbrechen' | mrTranslate }}
                </button>
              }

              <button class="btn btn-icon btn-success" (click)="copyItem('wert')" [disabled]="!copiedWerte().length">
                <cds-icon shape="paste" />
                {{ 'Einfügen' | mrTranslate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <clr-modal [(clrModalOpen)]="isOpenModalZaehlerName">
    <h3 class="modal-title">
      {{ (!selectedNameID() ? 'Ein neues ' + formType + 'objekt erstellen' : formType + ' bearbeiten') | mrTranslate }}
    </h3>
    <div class="modal-body clr-row nxm">
      <form
        id="zaehler-name-form"
        clrForm
        [formGroup]="nameGroupForm"
        (ngSubmit)="saveItem('name')"
        class="clr-col-12 width100"
        clrLayout="horizontal"
        [clrLabelSize]="4">
        <clr-input-container>
          <label>{{ 'Code' | mrTranslate }}</label>
          <input clrInput type="text" formControlName="Code" [autofocus]="isOpenModalZaehlerName()" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
          </clr-control-error>
          <clr-control-error *clrIfError="'in-Table'; error as err">
            {{ err | mrTranslate }}
          </clr-control-error>
        </clr-input-container>

        <clr-input-container>
          <label>{{ 'Bezeichnung' | mrTranslate }}</label>
          <input clrInput type="text" formControlName="Bezeichnung" />
        </clr-input-container>

        <clr-toggle-container clrInline>
          <label>{{ 'Toleranzen' | mrTranslate }}</label>
          <clr-toggle-wrapper>
            <input clrToggle formControlName="isSR100" type="checkbox" />
            <label>{{ 'aktivSR100' | transformColNames: tol() }} {{ 'aktiv' | mrTranslate }}</label>
          </clr-toggle-wrapper>
          <clr-toggle-wrapper>
            <input clrToggle formControlName="isSRG" type="checkbox" />
            <label>{{ 'aktivSRG' | transformColNames: tol() }} {{ 'aktiv' | mrTranslate }}</label>
          </clr-toggle-wrapper>
        </clr-toggle-container>

        @if (isMessGeraetOptionOn()) {
          <fieldset class="margin-24-tb">
            <legend>{{ 'Gleisbezeichner' | mrTranslate }}</legend>
            <form clrForm #trackForm [formArray]="trackFormArray" clrLayout="horizontal" [clrLabelSize]="4">
              @if (trackFormArray.errors) {
                <clr-alert class="clr-col-12" clrAlertType="danger" [clrAlertClosable]="false">
                  <clr-alert-item>
                    <span class="alert-text">
                      @if (trackFormArray.errors['track-used-already']) {
                        {{ 'Strang kann nicht wiederholt werden' | mrTranslate }}
                      } @else if (trackFormArray.errors['track-anlage-als-wert']) {
                        {{ "Strang 'Anlage' kann nur alleine benutzt werden" | mrTranslate }}
                      }
                    </span>
                  </clr-alert-item>
                </clr-alert>
              }
              @for (control of trackFormArray.controls; track $index) {
                <clr-select-container>
                  <label>{{ 'Strang' | mrTranslate }} {{ $index + 1 }}</label>
                  <select clrSelect [formControlName]="$index">
                    @for (track of Track_Map | keyvalue; track track.key) {
                      <option [ngValue]="+track.key">{{ track.value }}</option>
                    }
                  </select>
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Strang muss ausgefüllt oder gelöscht werden' | mrTranslate }}
                  </clr-control-error>
                </clr-select-container>
              }
              <div class="btn-group btn-icon margin-24-tb">
                <button type="button" class="btn" (click)="addTrack()" [disabled]="trackFormArray.length == 4">
                  <clr-tooltip>
                    <cds-icon clrTooltipTrigger shape="plus" />
                    <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                      {{ 'Strang hinzufügen' | mrTranslate }}
                    </clr-tooltip-content>
                  </clr-tooltip>
                </button>
                <button
                  type="button"
                  class="btn btn-danger-outline"
                  (click)="deleteTrack()"
                  [disabled]="trackFormArray.length == 1"
                  [clrLoading]="trackResetState()">
                  <clr-tooltip>
                    <cds-icon clrTooltipTrigger shape="times" />
                    <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                      {{ 'Strang löschen' | mrTranslate }}
                    </clr-tooltip-content>
                  </clr-tooltip>
                </button>
              </div>
            </form>
          </fieldset>
        }

        <clr-select-container>
          <label>{{ 'Messpunktskizze' | mrTranslate }}</label>
          <select clrSelect formControlName="Bild">
            <option [ngValue]="null">{{ 'Keine' | mrTranslate }}</option>
            @for (skizze of skizzenListe(); track skizze) {
              <option [value]="skizze">{{ skizze }}</option>
            }
          </select>
        </clr-select-container>
      </form>
      <ng-container *ngTemplateOutlet="preview; context: { readonly: false }" />
    </div>
    <div class="modal-footer">
      <button type="submit" form="zaehler-name-form" class="btn btn-primary" [disabled]="nameGroupForm.invalid">
        {{ 'OK' | mrTranslate }}
      </button>
      <button type="button" class="btn" (click)="isOpenModalZaehlerName.set(false)">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </clr-modal>

  <ng-container [w-media-query]="{ min: 768 }" #query="query">
    <clr-modal [(clrModalOpen)]="isOpenModalZaehlerWert" [clrModalSize]="query.matches ? 'lg' : 'full-screen'">
      <div class="modal-title">
        <h3>
          {{
            selectedWert()?.ID ? formType + 'wert bearbeiten' : ('Neuen ' + formType + 'wert erstellen' | mrTranslate)
          }}
        </h3>
      </div>
      <div class="modal-body grid" id="grid-container">
        <form
          id="wert-form"
          #wertForm
          clrForm
          #fW="ngForm"
          [formGroup]="wertGroupForm"
          (ngSubmit)="saveItem('wert')"
          [clrLabelSize]="4"
          class="width100 grid no-margin"
          clrLayout="horizontal">
          <div class="span-row" role="grid-row-placeholder" aria-hidden="true"></div>
          @if (selectedWert()?.ID && werte(); as list) {
            <div id="nav-row" class="grid">
              @if (wertIndex() != 0) {
                <button
                  type="button"
                  class="btn btn-link np nm text-right w-100-p clr-justify-content-end"
                  data-area="prev"
                  style="justify-self: end"
                  (click)="nextWert(-1, $event)"
                  [title]="'vorherige Wert öffnen' | mrTranslate">
                  <span class="ellipsis">{{ (list | at: wertIndex() - 1)?.Code }}</span>
                </button>
              }
              <button
                [clrLoading]="wertState()"
                type="button"
                class="btn np nm btn-link btn-state btn-state-custom-size"
                data-area="prev-btn"
                [disabled]="wertIndex() == 0"
                (click)="nextWert(-1, $event)"
                [title]="'vorherige Wert öffnen' | mrTranslate">
                <cds-icon shape="circle-arrow" direction="left" />
              </button>
              <button
                [clrLoading]="wertState()"
                type="button"
                class="btn np nm btn-link btn-state btn-state-custom-size"
                data-area="next-btn"
                [disabled]="wertIndex() == list.length - 1"
                (click)="nextWert(1, $event)"
                [title]="'nächste Wert öffnen' | mrTranslate">
                <cds-icon shape="circle-arrow" direction="right" />
              </button>
              @if (wertIndex() != list.length - 1) {
                <button
                  type="button"
                  class="btn btn-link np nm text-left w-100-p clr-justify-content-start"
                  data-area="next"
                  style="justify-self: start"
                  (click)="nextWert(1, $event)"
                  [title]="'nächste Wert öffnen' | mrTranslate">
                  <span class="ellipsis">{{ (list | at: wertIndex() + 1)?.Code }}</span>
                </button>
              }
            </div>
          }
          <clr-input-container class="span-2" data-area="code">
            <label>{{ 'Code' | mrTranslate }}</label>
            <input
              clrInput
              type="text"
              formControlName="Code"
              [autofocus]="isOpenModalZaehlerWert() && selectedWert() != null" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            <clr-control-error *clrIfError="'in-Table'; error as err">
              {{ err | mrTranslate }}
            </clr-control-error>
          </clr-input-container>
          <clr-input-container class="span-2" data-area="bezeichnung">
            <label>{{ 'Bezeichnung' | mrTranslate }}</label>
            <input clrInput type="text" formControlName="Bezeichnung" />
          </clr-input-container>
          @if (!isMessGeraetOptionOn()) {
            <clr-toggle-container class="span-2" data-area="is-header">
              <clr-toggle-wrapper>
                <input clrToggle formControlName="isHeader" type="checkbox" />
                <label>{{ 'Überschrift' | mrTranslate }}</label>
              </clr-toggle-wrapper>
            </clr-toggle-container>
          }
          @if (!wertGroupForm.get('isHeader').value) {
            @if (isMessGeraetOptionOn() && selectedName(); as name) {
              <clr-select-container class="span-2" data-area="z-type">
                <label>{{ 'Zählertype' | mrTranslate }}</label>
                <select clrSelect formControlName="ZType">
                  @for (typ of ZType_Map | keyvalue: null; track typ.key) {
                    <option [ngValue]="+typ.key">{{ typ.value }}</option>
                  }
                </select>
                <clr-control-error *clrIfError="'required'">
                  {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                </clr-control-error>
              </clr-select-container>
              @if (availableTracks().length > 1) {
                <clr-select-container class="span-2" data-area="track-index">
                  <label>{{ 'Gleis' | mrTranslate }}</label>
                  <select clrSelect formControlName="Track">
                    @for (track of availableTracks(); track $index) {
                      <option [ngValue]="$index">{{ Track_Map.get(track) }}</option>
                    }
                  </select>
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </clr-control-error>
                  <clr-control-error *clrIfError="'max'">
                    {{ 'Strang wurde deaktiviert' | mrTranslate }}
                  </clr-control-error>
                </clr-select-container>
              }
            } @else {
              <clr-select-container class="span-2" data-area="z-art">
                <label>{{ 'Zählerart' | mrTranslate }}</label>
                <select clrSelect formControlName="ZArt">
                  @for (typ of ZArt_Map | keyvalue: null; track typ.key) {
                    <option [ngValue]="+typ.key">{{ typ.value }}</option>
                  }
                </select>
              </clr-select-container>
            }
            @if (wertGroupForm.get('ZArt').value; as zArt) {
              @if (ZArt_Options.get(+zArt); as mode) {
                <ng-container
                  *ngTemplateOutlet="
                    input;
                    context: { label: 'Soll-Wert', control: 'Soll', area: 'soll', mode: mode.soll }
                  " />
                @if (mode.soll.input == 'Select' || mode.minus || mode.plus) {
                  <!-- Toleranzen -->
                  <div class="grid span-row" id="tol-block">
                    <!-- SR 100 -->
                    @if (selectedName()?.isSR100) {
                      <clr-toggle-container data-area="sr100-aktiv" class="span-4">
                        <clr-toggle-wrapper class="min-w-max-c">
                          <input clrToggle formControlName="aktivSR100" type="checkbox" />
                          <label>{{ 'aktivSR100' | transformColNames: tol() }} {{ 'aktiv' | mrTranslate }}</label>
                        </clr-toggle-wrapper>
                      </clr-toggle-container>
                      @if (wertGroupForm.get('aktivSR100').value) {
                        @if (mode.minus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SR100minus' | transformColNames: tol(),
                                control: 'SR100minus',
                                area: 'sr100-minus',
                                mode: mode.minus,
                              }
                            " />
                        }
                        @if (mode.plus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SR100plus' | transformColNames: tol(),
                                control: 'SR100plus',
                                area: 'sr100-plus',
                                mode: mode.plus,
                              }
                            " />
                        }
                      }
                    }
                    <!-- SR lim -->
                    @if (true) {
                      <!-- sonst css sieht es als ersten Block -->
                      <clr-toggle-container data-area="srlim-aktiv" class="span-4">
                        <clr-toggle-wrapper class="min-w-max-c">
                          <input clrToggle formControlName="aktivSRlimm" type="checkbox" />
                          <label>{{ 'aktivSRlimm' | transformColNames: tol() }} {{ 'aktiv' | mrTranslate }}</label>
                        </clr-toggle-wrapper>
                      </clr-toggle-container>
                      @if (wertGroupForm.get('aktivSRlimm').value) {
                        @if (mode.minus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SRlimminus' | transformColNames: tol(),
                                control: 'SRlimminus',
                                area: 'srlim-minus',
                                mode: mode.minus,
                              }
                            " />
                        }
                        @if (mode.plus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SRlimplus' | transformColNames: tol(),
                                control: 'SRlimplus',
                                area: 'srlim-plus',
                                mode: mode.plus,
                              }
                            " />
                        }
                      }
                    }
                    <!-- SRG -->
                    @if (selectedName()?.isSRG) {
                      <clr-toggle-container data-area="srg-aktiv" class="span-4">
                        <clr-toggle-wrapper class="min-w-max-c">
                          <input clrToggle formControlName="aktivSRG" type="checkbox" />
                          <label>{{ 'aktivSRG' | transformColNames: tol() }} {{ 'aktiv' | mrTranslate }}</label>
                        </clr-toggle-wrapper>
                      </clr-toggle-container>
                      @if (wertGroupForm.get('aktivSRG').value) {
                        @if (mode.minus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SRGminus' | transformColNames: tol(),
                                control: 'SRGminus',
                                area: 'srg-minus',
                                mode: mode.minus,
                              }
                            " />
                        }
                        @if (mode.plus) {
                          <ng-container
                            *ngTemplateOutlet="
                              input;
                              context: {
                                label: 'SRGplus' | transformColNames: tol(),
                                control: 'SRGplus',
                                area: 'srg-plus',
                                mode: mode.plus,
                              }
                            " />
                        }
                      }
                    }
                  </div>
                  <clr-select-container class="span-2" data-area="einheit">
                    <label class="d-f row w-100-p">
                      <span class="clr-col nxp ellipsis">
                        {{ 'Einheit' | mrTranslate }}
                      </span>
                      <button
                        class="btn btn-sm btn-icon btn-outline clr-col-auto"
                        style="margin: -7px 0; float: inline-end"
                        tabindex="-1"
                        type="button"
                        [title]="'Tabelle verwalten' | mrTranslate"
                        (click)="isOpenModalZaehlerEinheit.set(true)">
                        <cds-icon shape="pencil" />
                      </button>
                    </label>
                    <!-- button für Bearbeiten -->
                    <select clrSelect formControlName="ZEinheit" name="ZEinheit">
                      @for (einheit of meh(); track einheit.ID) {
                        <option [ngValue]="+einheit.ID">{{ einheit.Code }}</option>
                      }
                    </select>
                    <clr-control-error *clrIfError="'required'">
                      {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                    </clr-control-error>
                  </clr-select-container>
                  <div class="span-2" data-area="genau-sliders" id="genauSliders">
                    <ng-container *ngTemplateOutlet="query.matches ? dropdown : inline" />
                  </div>
                  <ng-template #slider let-control="control">
                    <ngx-slider [formControlName]="control" [options]="{ floor: 0, ceil: 4, animate: false }" />
                  </ng-template>
                  <ng-template #dropdown>
                    <clr-dropdown [clrCloseMenuOnItemClick]="false">
                      <button type="button" class="btn btn-icon btn-link" clrDropdownTrigger>
                        <cds-icon shape="bullseye" solid="true" style="color: brown" />
                        <cds-icon shape="angle" direction="right" />
                      </button>
                      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right" style="min-width: 30vw">
                        <span class="dropdown-header" aria-hidden="true">
                          {{ 'Genauigkeiten' | mrTranslate }}
                        </span>
                        <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
                        <span class="dropdown-header" aria-hidden="true">
                          {{ 'Soll' | mrTranslate }}
                        </span>
                        <button clrDropdownItem type="button">
                          <ng-container *ngTemplateOutlet="slider; context: { control: 'SGenau' }" />
                        </button>
                        <div class="dropdown-divider" role="separator" aria-hidden="true"></div>
                        <span class="dropdown-header" aria-hidden="true">
                          {{ 'Toleranzen' | mrTranslate }}
                        </span>
                        <button clrDropdownItem type="button">
                          <ng-container *ngTemplateOutlet="slider; context: { control: 'TGenau' }" />
                        </button>
                      </clr-dropdown-menu>
                    </clr-dropdown>
                  </ng-template>
                  <ng-template #inline>
                    <div class="clr-row clr-form-control">
                      <label class="clr-control-label clr-col-4 nym">
                        {{ 'Genauigkeit' | mrTranslate }}
                      </label>
                      <div class="clr-col">
                        <span class="clr-control-label">{{ 'Soll' | mrTranslate }}</span>
                        <ng-container *ngTemplateOutlet="slider; context: { control: 'SGenau' }" />
                      </div>
                      <div class="clr-col">
                        <span class="clr-control-label">{{ 'Tol' | mrTranslate }}</span>
                        <ng-container *ngTemplateOutlet="slider; context: { control: 'TGenau' }" />
                      </div>
                    </div>
                  </ng-template>
                }
              }
            }
            <ng-template #input let-label="label" let-control="control" let-mode="mode" let-area="area">
              <ng-container *ngTemplateOutlet="mode.input != 'Num' ? textInput : numberInput" />
              <ng-template #textInput>
                <clr-input-container class="span-2" [attr.data-area]="area">
                  <label>{{ label | mrTranslate }}</label>
                  <input clrInput [value]="mode.text" type="text" readonly />
                </clr-input-container>
              </ng-template>
              <ng-template #numberInput>
                <clr-number-input-container class="span-2" [attr.data-area]="area">
                  <label>{{ label | mrTranslate }}</label>
                  <input clrNumberInput [formControlName]="control" type="number" />
                  <clr-control-error *clrIfError="'required'">
                    {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                  </clr-control-error>
                </clr-number-input-container>
              </ng-template>
            </ng-template>
          }
        </form>
      </div>
      <div class="modal-footer">
        <!-- [disabled]="wertGroupForm.invalid" -->
        <button type="button" class="btn btn-primary" (click)="fW.ngSubmit.emit()">
          {{ 'OK' | mrTranslate }}
        </button>
        <button type="button" class="btn" (click)="isOpenModalZaehlerWert.set(false)">
          {{ 'Abbrechen' | mrTranslate }}
        </button>
      </div>
    </clr-modal>
  </ng-container>
</div>

<ng-template #preview let-readonly="readonly">
  <app-preview-thumbnails
    [acceptTypes]="'.png'"
    [maxAmount]="1"
    [readonly]="readonly"
    [showCamera]="false"
    [isSkizze]="true"
    (lastUpload)="setBildInForm($event)"
    (clearedThumb)="setBildInForm(null)"
    [allowCameraVideo]="false" />
</ng-template>

<app-hilfe-beschreibung-modal [(isModalOpen)]="isOpenModalHelper" [id]="selectedNameID()" [table]="'SZAEHN'" />

@if (isOpenModalZaehlerEinheit()) {
  <app-zaehler-einheiten [otypid]="otypid()" [(modalOpen)]="isOpenModalZaehlerEinheit" (refresh)="mehRs.reload()" />
}

@if (isOpenModalZaehlerImport()) {
  <app-zaehler-import
    [otypid]="otypid()"
    [(modalOpen)]="isOpenModalZaehlerImport"
    (refresh)="zaehlerNamesRs.reload()" />
}
@if (isOpenModalSkizzen()) {
  <app-edit-skizzen-points
    [(isModalOpen)]="isOpenModalSkizzen"
    [skizze]="{ base64: selectedSkizze(), name: skizzenName() }"
    [zWerteCodes]="zWerteCodes()" />
}
